import { useState, useLayoutEffect } from "react";

export const usePreloadImages = (imageUrls: string[]): boolean => {
  const [loaded, setLoaded] = useState(false);

  useLayoutEffect(() => {
    let loadedCount = 0;
    imageUrls.forEach((url) => {
      const img = new Image();
      img.src = url;
      img.onload = img.onerror = () => {
        loadedCount++;
        if (loadedCount === imageUrls.length) {
          setLoaded(true);
        }
      };
    });
  }, [imageUrls]);

  return loaded;
};
